import { computed } from "vue";
import { isDeveloperMode } from "../components/developers/developerMode";
import { can as canfunc, cannot as cannotfunc } from '@/components/permissions-handler/helpers/usePermissions'
import { useLanguageStore } from "../pinia/LanguageStore";
import moment from "moment";
import { useCurrentUserStore } from "@/pinia/CurrentUserStore";
import { useRouteHelperStore } from "@/pinia/RouteHelperStore";

export function disable_navigation(status) {
    const routeHelperStore = useRouteHelperStore();
    routeHelperStore.disable_navigation = status;
}
export const navigation_disabled = computed(() => {
    const routeHelperStore = useRouteHelperStore();
    return routeHelperStore.disable_navigation;
})

export function createUuid() {
    try {
        return window.crypto.randomUUID();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
        return (
            "_" +
            Math.random().toString(36).slice(-18) +
            "_" +
            Math.random().toString(36).slice(-18)
        );
    }
}

export const isLooseDeepEqual = (object1, object2) => {

    const objKeys1 = Object.keys(object1);
    const objKeys2 = Object.keys(object2);

    if (objKeys1.length !== objKeys2.length){
        return false;

    }

    for (var key of objKeys1) {
        const value1 = object1[key];
        const value2 = object2[key];

        const isObjects = isObject(value1) && isObject(value2);

        if ((isObjects && !isLooseDeepEqual(value1, value2)) ||
            (!isObjects && value1 != value2)
        ) {
            return false;
        }
    }
    return true;
};

export const isDeepEqual = (object1, object2) => {

    const objKeys1 = Object.keys(object1);
    const objKeys2 = Object.keys(object2);

    if (objKeys1.length !== objKeys2.length) return false;

    for (var key of objKeys1) {
        const value1 = object1[key];
        const value2 = object2[key];

        const isObjects = isObject(value1) && isObject(value2);

        if ((isObjects && !isDeepEqual(value1, value2)) ||
            (!isObjects && value1 !== value2)
        ) {
            return false;
        }
    }
    return true;
};

const isObject = (object) => {
    return object != null && typeof object === "object";
};

export const can = (flag) => {
    return canfunc(flag);
}

export const cannot = (flag) => {
    return cannotfunc(flag);
}

export const useDebugMode = () => {
    const isDebug = computed(() => {
            return isDeveloperMode.value;
    })
    return isDebug;
}

export const locale = () => {
      const languageStore = useLanguageStore();
    return languageStore.locale ?? "en";
}
export const __ = (key, para) => {
            const languageStore = useLanguageStore();
            return languageStore.__(key, para);
        }

 export const phpToMoment = (str/*: string*/) => {
            let replacements/*: {[key: string] : string}*/ = {
                d: "DD",
                D: "ddd",
                j: "D",
                l: "dddd",
                N: "E",
                S: "o",
                w: "e",
                z: "DDD",
                W: "W",
                F: "MMMM",
                m: "MM",
                M: "MMM",
                n: "M",
                t: "", // no equivalent
                L: "", // no equivalent
                o: "YYYY",
                Y: "YYYY",
                y: "YY",
                a: "a",
                A: "A",
                B: "", // no equivalent
                g: "h",
                G: "H",
                h: "hh",
                H: "HH",
                i: "mm",
                s: "ss",
                u: "SSS",
                e: "zz", // deprecated since Moment.js 1.6.0
                I: "", // no equivalent
                O: "", // no equivalent
                P: "", // no equivalent
                T: "", // no equivalent
                Z: "", // no equivalent
                c: "", // no equivalent
                r: "", // no equivalent
                U: "X",
            };

            return str
                .split("")
                .map((chr) => (chr in replacements ? replacements[chr] : chr))
                .join("");
        }

export const __date = (date, format = false) => {
            if(!date || date == ""){
                return "";
            }
            const currentUser = useCurrentUserStore();
            moment.locale(locale());
            var momentDate = moment.tz(date, "UTC");
            if (!momentDate.isValid()) {
                return "";
            }
            if (format === false) {
                format =
                    currentUser.company_data.settings?.date_format ?? "Y-m-d";
            }
            var timezone =
                currentUser.current_timezone ??
                currentUser.company_data.settings?.date_timezone ??
                "UTC";
            if (!timezone || timezone == "") {
                timezone = "UTC";
            }
            return momentDate.tz(timezone).format(phpToMoment(format));
        }
